import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) { toast.success("Welcome back"); navigate("/dashboard"); }
    else toast.error(r.error);
  };

  return (
    <div data-testid="login-page" className="min-h-[70vh] grid place-items-center px-4 py-14">
      <div className="w-full max-w-md bg-[#FFFDF9] sacred-border rounded-3xl p-10 relative om-watermark">
        <div className="overline">Sign in</div>
        <h1 className="font-serif text-4xl text-[#4A0E17] mt-2">Welcome back, devotee</h1>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <Input data-testid="login-email" required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-white border-[#D4AF37]/40 h-12" />
          <Input data-testid="login-password" required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-white border-[#D4AF37]/40 h-12" />
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full bg-[#4A0E17] hover:bg-[#36080F] rounded-full h-12 text-base">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="text-sm text-[#63534E] text-center mt-6">
          New here? <Link to="/register" className="text-[#E65100] font-semibold">Create account</Link>
        </p>
      </div>
    </div>
  );
}
